module.exports = __webpack_public_path__ + "img/circular-green-tick.ba065a99.svg";